import { type DRSInfo, type DRSProvider } from "@/governance/types/drs"

/**
 * Empty provider for organizations without DRS support
 * Returns default empty values for all operations
 */
export class EmptyProvider implements DRSProvider {
  async getDRSInfo(_address: string): Promise<DRSInfo | null> {
    return null
  }

  async getBulkDRSInfo(_addresses: string[]): Promise<Map<string, DRSInfo>> {
    return new Map<string, DRSInfo>()
  }

  async initialize(): Promise<this> {
    return this
  }
}
